var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TradingAccountDataTable')
}
var staticRenderFns = []

export { render, staticRenderFns }